import React from 'react'
import type { Market } from 'apollo-gql'
import cn from 'classnames'
import { isIndexedLanguage } from 'lib/markets'

import CtaLink from 'components/CtaLink/CtaLink'
import Heading from 'components/Heading/Heading'
import MarketFlag from 'components/MarketFlag/MarketFlag'

import styles from './MarketOption.module.css'

type HandleMarketChangeProps = {
  marketId: string
  languageId?: string
}

type MarketOptionProps = {
  market: Market
  handleMarketChange: ({
    marketId,
    languageId,
  }: HandleMarketChangeProps) => void
  selected?: boolean
  featuredMarket?: boolean
}

const MarketOption = ({
  market,
  handleMarketChange,
  selected,
  featuredMarket,
}: MarketOptionProps) => (
  <div
    className={cn(styles.marketOption, {
      [styles.marketOptionSelected]: selected,
      [styles.featuredMarket]: featuredMarket,
    })}
  >
    <a
      href={`/${market.id}/${market.defaultLanguage.code}`}
      onClick={(e) => {
        e.preventDefault()
        handleMarketChange({ marketId: market.id })
      }}
      style={{ display: 'block' }}
      tabIndex={0}
    >
      <div className={styles.marketWrapper}>
        <Heading noMargin level="h4">
          <h2 className={styles.marketHeading}>{market.name}</h2>
          <span className={styles.flag}>
            <MarketFlag market={market} />
          </span>
        </Heading>
      </div>
    </a>

    {market.languages && market.languages.length > 0 && (
      <div className={styles.languages}>
        {market.languages.map((language) => (
          <React.Fragment key={language.id}>
            <div className={styles.language}>
              <CtaLink
                {...(isIndexedLanguage(market, language)
                  ? {}
                  : { rel: 'nofollow' })}
                href={`/${market.id}/${language.code}`}
                onClick={(e) => {
                  e.preventDefault()
                  handleMarketChange({
                    marketId: market.id,
                    languageId: language.id,
                  })
                }}
              >
                {language.native}
              </CtaLink>
            </div>
          </React.Fragment>
        ))}
      </div>
    )}
  </div>
)

export default MarketOption
